import { Alert, Typography, notification } from "antd";
import classnames from "classnames";
import { get } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdCheck, MdContentCopy } from "react-icons/md";
import Button from "shared/components/Button";
import { NAME_SPACES } from "shared/locales/constants";

const { Text } = Typography;

const SecretFields = ({ secret, onDone }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.BROKER);
  const API_KEY = t("API_KEY", { returnObjects: true });

  const [copied, setCopied] = useState(null);

  const copy = async (value, label, field) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(field);
      setTimeout(
        () => setCopied((current) => (current === field ? null : current)),
        2000,
      );
      notification.success({ message: `${label} ${API_KEY.COPIED}` });
    } catch (error) {
      notification.error({ message: API_KEY.COPY_FAILED });
    }
  };

  const CopyField = ({ label, value, field, sensitive }) => (
    <div className="api-credential__field">
      <span className="api-credential__label">{label}</span>
      <div className="api-credential__row">
        <code
          title={value}
          className={classnames("api-credential__value", {
            "api-credential__value--sensitive": sensitive,
          })}
        >
          {value}
        </code>
        <Button
          className="api-credential__copy"
          type={copied === field ? "primary" : "primary--outlined"}
          icon={
            copied === field ? (
              <MdCheck size={18} />
            ) : (
              <MdContentCopy size={18} />
            )
          }
          onClick={() => copy(value, label, field)}
        >
          {copied === field ? API_KEY.COPIED_SHORT : API_KEY.COPY}
        </Button>
      </div>
    </div>
  );

  return (
    <>
      <Alert
        type="warning"
        showIcon
        className="m-bottom-16"
        message={API_KEY.SECRET_ONCE_TITLE}
        description={API_KEY.SECRET_ONCE_BODY}
      />
      <CopyField
        label={API_KEY.API_KEY}
        value={get(secret, "apiKey")}
        field="apiKey"
        sensitive
      />
      <Text type="secondary">{API_KEY.API_KEY_HELP}</Text>
      <div className="m-bottom-16" />
      <Button block type="primary" onClick={onDone}>
        {API_KEY.DONE}
      </Button>
    </>
  );
};

export default SecretFields;
